import { Paper } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Logo from "./Logo";

export default function TopLogoPanel({
  children = "",
  elevation = 6,
  ...props
}) {
  return (
    <div className="relative w-full">
      <Box
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        className="absolute w-full transform -translate-y-1/2 flex justify-center"
      >
        <Logo shadow />
      </Box>
      <div className="relative w-full">
        <Paper className="sm:p-10 sm:pt-20 p-5 pt-20" elevation={elevation}>
          {children}
        </Paper>
      </div>
    </div>
  );
}
